module.exports = __webpack_public_path__ + "ae3b7d84377bda5d0419ac656629291f.svg";